import { render, staticRenderFns } from "./orgProfilesOlympiad.vue?vue&type=template&id=0784419e&scoped=true&"
import script from "./orgProfilesOlympiad.vue?vue&type=script&lang=js&"
export * from "./orgProfilesOlympiad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0784419e",
  null
  
)

export default component.exports